/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetSettingsContainer_user$ref: FragmentReference;
export type WidgetSettingsContainer_user = {|
  +id: string,
  +$refType: WidgetSettingsContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetSettingsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '84a2914ef404b266baa43b151aaf86a0';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Widgets/__generated__/WidgetSettingsContainer_user.graphql.js